import { Component, signal } from '@angular/core';
import { Site } from 'app/classes/site';
import { IGetEnergyAsset, AssetService } from 'app/shared/asset.service';
import { SiteService } from 'app/shared/site.service';
import { EnergyService, IMeterItemDaily, IMeterItemMonthly } from 'app/shared/energy.service';
import { DateService } from 'app/shared/date.service';
import { APIService } from 'app/shared/api.service';
import { ExportService } from 'app/shared/export.service';
@Component({
  selector: 'app-energy-meters',
  standalone: false,
  templateUrl: './energy-meters.component.html',
  styleUrl: './energy-meters.component.css'
})
export class EnergyMetersComponent {

  meters = signal<IMeterItemMonthly[]>(null);

  metersDaily = signal<IMeterItemDaily[]>(null);

  sites = signal<Site[]>([]);

  months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  monthsFull = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  daysInMonth: number;
  month = signal<number>(null);
  grandTotals: number[];

  tabIndex = signal<number>(0);

  currentYear = new Date().getFullYear();
  onYear = signal<number>(null);
  hasMultipleYears = false;
  minYear: number;
  details: any;

  days = signal<number[]>([]);
  dayNames = signal<string[]>([]);

  constructor(private assetService: AssetService, private siteService: SiteService, private energyService: EnergyService, private apiService: APIService, private exportService: ExportService) {
    this.localStorageGet();

    this.getMeters();
  }

  getMeters() {
    this.meters.set(null);
    this.grandTotals = [null, null, null, null, null, null, null, null, null, null, null, null];

    this.energyService.getMeters(this.onYear()).then(meters => {
      this.meters.set(meters.meters);
      this.details = meters.details;

      this.minYear = meters.details.minYear;
      this.hasMultipleYears = meters.details.minYear < this.currentYear;
      return;
    });

  }

  localStorageGet() {
    const storageString = JSON.parse(localStorage.getItem('energy:assets:list') || "{}");
    this.onYear.set(storageString.year || new Date().getFullYear());
  }

  localStorageSave() {
    localStorage.setItem('energy:assets:list', JSON.stringify({ year: this.onYear() }));
  }

  goBack() {
    if (this.onYear() === 2022) {
      return;
    }
    this.onYear.set(this.onYear() - 1);
    this.localStorageSave();
    this.getMeters();
  }

  goForward() {
    if (this.onYear() === this.currentYear) {
      return;
    }
    this.onYear.set(this.onYear() + 1);
    this.localStorageSave();
    this.getMeters();
  }

  tabIndexSet(index: number) {
    this.tabIndex.set(index);
  }

  goToMonth(index: number) {
    console.log("goToMonth", index);
    this.month.set(index);
    const month = index + 1;
    this.metersDaily.set(null);

    this.daysInMonth = DateService.getDaysInMonth(this.onYear(), month);
    this.days.set([null, ...Array.from({ length: this.daysInMonth }, (_, i) => i + 1)]);
    this.dayNames.set([null, ...DateService.getWeekdayNamesForMonth(this.onYear(), month)]);
    this.energyService.getMetersForMonth(month, this.onYear()).then(meters => {
      this.metersDaily.set(meters.meters);
      console.log(meters);

    });
  }

  export() {
    this.apiService.toastSuccess('Exporting report...', null, 500);
    this.exportService.exportMeterList(this.onYear(), this.meters(), this.apiService.getUserOrg().shortTitle);
  }
}
